import React from "react";
import albert from "../../assets/img/albert.webp";
import licinda from "../../assets/img/lucinda.webp";

const Team = () => {
  return (
    <div className="bg-soft container-fluid p-0 p-lg-5">
      <h2 className="fs-40 fs-700 text-center mb-5 p-md-3 p-2 p-lg-0">
        Meet your Invisalign® dentists
      </h2>
      {/* <p className="fs-16 text-center mb-5">People who made us successful</p> */}

      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 mb-4">
            <img
              src={albert}
              alt="Dr Naiz Khan"
              className="img-fluid mb-3 w-100 rounded-4"
              loading="lazy"
            />
            <h3 className="fs-36 fw-600">Dr. Naiz</h3>
            <p className="fs-14">
              Cosmetic Dentist |{" "}
              <a
                className="text-dark"
                href="https://olr.gdc-uk.org/SearchRegister/SearchResult?RegistrationNumber=101469"
                target="blank"
              >
                GDC No 101469
              </a>{" "}
              | BDS Brist,United Kingdom, 2005
            </p>
            <p className="fs-14">
              Dr Naiz Khan qualified from the University of Bristol in 2005 and
              has spent the last 15 years treating thousands of patients in
              Gloucester, Cheltenham, Banbury and Worcester.
              <br />
              <br />
              With a keen interest in orthodontics, Dr Naiz has been providing
              teeth straightening solutions with Invisalign® for nearly a decade
              now to treat a variety of orthodontic concerns including teeth
              that are crooked, crowded or spaced out. Dr Naiz is one of the
              UK’s leading providers of Invisalign® treatments and is part of
              the Apex group of providers which recognises him as one of the top
              1% of Invisalign® providers in the country.
              <br />
              <br />
              His aim is to create a long lasting, friendly, and professional
              relationship based on honesty and trust with every patient, so
              that they are at ease when receiving the very best care.
              <br />
              <br />
              Dr Naiz gets his job satisfaction from being able to combine the
              art and science of dentistry to help create smiles, which help
              increase confidence and self-esteem in his patients.
              <br />
              <br />
              Dr Naiz spends his time outside of surgery with his young children
              and supporting other dentists with their clinical skills.
            </p>
          </div>

          <div className="col-12 col-md-6 mb-4">
            <img
              src={licinda}
              alt="Dr. Naeem"
              className="img-fluid mb-3 w-100 rounded-4"
              loading="lazy"
            />
            <h3 className="fs-36 fw-600">Dr. Naeem</h3>
            <p className="fs-14">
              Cosmetic Dentist |{" "}
              <a
                className="text-dark"
                href="https://olr.gdc-uk.org/SearchRegister/SearchResult?RegistrationNumber=283591"
                target="blank"
              >
                GDC No 283591
              </a>{" "}
              | BDS (2019)
            </p>
            <p className="fs-14">
              Dr. Naeem is a compassionate and skilled general dentist dedicated
              to delivering exceptional patient care. A graduate of the
              University of Manchester in 2019, Dr Naeem brings extensive
              experience in oral surgery, having worked in a hospital setting
              where they handled complex soft and hard tissue cases.
              <br />
              <br />
              With a passion for enhancing smiles, Dr. Naeem is also a highly
              trained cosmetic dentist, offering treatments such as composite
              bonding, porcelain veneers, teeth whitening, and Invisalign®.
              Beyond aesthetics, Dr. Naeem is experienced in rehabilitating
              patients’ mouths, providing solutions for tooth wear and restoring
              broken-down teeth to their optimal health and function.
              <br />
              <br />
              Dr. Naeem is committed to creating a comfortable, relaxing
              environment for patients and is especially skilled in treating
              those who may feel nervous or anxious about dental visits.
              Understanding each patient’s unique needs, Dr. Naeem ensures that
              every treatment is as stress-free and enjoyable as possible.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
